module.exports = __webpack_public_path__ + "static/media/gnome.44778f64.png";